import { create } from 'zustand'

export interface AppNotification {
  id: string
  type: 'success' | 'error' | 'info' | 'warning'
  message: string
  timestamp: Date
  read: boolean
}

interface NotificationStore {
  notifications: AppNotification[]
  unreadCount: number
  add: (type: AppNotification['type'], message: string) => void
  markAllRead: () => void
  clear: () => void
  dismiss: (id: string) => void
}

let counter = 0

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  unreadCount: 0,

  add: (type, message) => {
    const id = `notif-${Date.now()}-${++counter}`
    const notification: AppNotification = {
      id,
      type,
      message,
      timestamp: new Date(),
      read: false,
    }
    set((s) => ({
      notifications: [notification, ...s.notifications].slice(0, 100),
      unreadCount: s.unreadCount + 1,
    }))

    // Auto-mark read after 10s (stays in list though)
    setTimeout(() => {
      const state = get()
      const n = state.notifications.find((x) => x.id === id)
      if (n && !n.read) {
        set((s) => ({
          notifications: s.notifications.map((x) => (x.id === id ? { ...x, read: true } : x)),
          unreadCount: Math.max(0, s.unreadCount - 1),
        }))
      }
    }, 10_000)
  },

  markAllRead: () =>
    set((s) => ({
      notifications: s.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  dismiss: (id) =>
    set((s) => {
      const n = s.notifications.find((x) => x.id === id)
      return {
        notifications: s.notifications.filter((x) => x.id !== id),
        unreadCount: n && !n.read ? Math.max(0, s.unreadCount - 1) : s.unreadCount,
      }
    }),

  clear: () => set({ notifications: [], unreadCount: 0 }),
}))
